import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Card, Col, message, Row } from 'antd';
import moment from 'moment';
import { queryMaterialDocumentInfo } from '@api/administrative/material';
import DescriptionList from '@comm/DescriptionList';
import { BackBtn } from '@comm/BackBtn';
import { queryFilePreview } from '@api/pub/attachment';
import { Link } from 'react-router';

const { Description } = DescriptionList;

class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        files: [],
      },
    };
  }

  componentDidMount() {
    const { uuid } = this.props.params;
    queryMaterialDocumentInfo({ uuid }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: res.data,
        });
      } else {
        message.error(res.message, 2.5);
      }
    });
  }

  render() {
    const { data } = this.state;
    return (
      <div>
        <Row style={{ marginBottom: '20px' }}>
          <Col>
            <BackBtn />
          </Col>
        </Row>
        <Card title="文件详情">
          <DescriptionList size="large" col={3}>
            <Description term="资料名称">{data.name}</Description>
            <Description term="资料编号">{data.no}</Description>
            <Description term="资料类型">{data.type}</Description>
            <Description term="资料状态">{data.status === 1 ? '有效' : '失效'}</Description>
            <Description term="资料周期">
              {data.beginDate ? moment(data.beginDate).format('YYYY-MM-DD') : ''}至
              {data.endDate ? moment(data.endDate).format('YYYY-MM-DD') : '永久'}
            </Description>
            <Description term="管理员">{data.manager}</Description>
            <Description term="归属公司">{data.company}</Description>
            <Description term="归属资料库">{data.database}</Description>
            <Description term="归属目录">{data.directory}</Description>
            <Description term="资料总数">{data.amount}</Description>
            <Description term="资料库存">{data.number}</Description>
          </DescriptionList>
          <DescriptionList size="large" col={2}>
            <Description term="资料备注说明">{data.remark}</Description>
          </DescriptionList>

          <DescriptionList size="large" col={3}>
            <Description term="是否续证">{data.isRenewal ? '是' : '否'}</Description>
            <Description term="续证经办人">{data.renewalUserName}</Description>
            <Description term="续证提醒时间">
              {data.renewalReminderDate
                ? moment(data.renewalReminderDate).format('yyyy-MM-DD')
                : null}
            </Description>
            {data.renewalUuid && (
              <Description term="续证申请">
                <Link to={`/administrative/material/renewal/open/${data.renewalUuid}`}>
                  查看详情
                </Link>
              </Description>
            )}
          </DescriptionList>

          <DescriptionList size="large" col={2}>
            <Description term="资料附件">
              {data.files.map(item => {
                return (
                  <div key={item.url}>
                    <a
                      onClick={() =>
                        queryFilePreview(item, `仅限${this.props.accountInfo.userName}查看`)
                      }
                    >
                      {item.name}
                    </a>
                  </div>
                );
              })}
            </Description>
          </DescriptionList>
        </Card>
      </div>
    );
  }
}

export default connect(state => ({
  accountInfo: state.account_info,
}))(Page);



// WEBPACK FOOTER //
// ./src/components/administrative/material/document/PageInfo.js